

export namespace Precision {
    export const Distance = 1e-7;
    export const Angle = 1e-3;
    export const Float = 1e-7;
}
